'use client';
import { Body } from './body';
import { Header } from './header';
import { LayoutProps } from '.';
import { locales } from '@spot-fe/utils';

export type LayoutContainerProps = LayoutProps;

export function LayoutContainer(props: LayoutContainerProps) {
  return (
    <>
      <Header {...props} locales={locales} />
      <Body {...props} locales={locales} />
    </>
  );
}
